import { render } from "./PieChart.vue?vue&type=template&id=22af9891&ts=true"
import script from "./PieChart.vue?vue&type=script&lang=ts"
export * from "./PieChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__